export default {
  en: {
    stopAndSend: 'Stop and send',
    startRecording: 'Start recording',
    requestingPermission: 'Requesting…',
  },
  ru: {
    stopAndSend: 'Остановить и отправить',
    startRecording: 'Начать запись',
    requestingPermission: 'Разрешение…', // ПОПРАВИТЬ
  },
  de: {
    stopAndSend: 'Stoppen und senden',
    startRecording: 'Aufnahme starten',
    requestingPermission: 'Berechtigung…',
  },
  pt: {
    stopAndSend: 'Parar e enviar',
    startRecording: 'Iniciar gravação',
    requestingPermission: 'Permissão…',
  },
  fr: {
    stopAndSend: 'Arrêter et envoyer',
    startRecording: 'Démarrer l’enregistrement',
    requestingPermission: 'Autorisation…',
  },
  es: {
    stopAndSend: 'Detener y enviar',
    startRecording: 'Iniciar grabación',
    requestingPermission: 'Permiso…',
  },
};
